// Lightweight dev-only logger. In production builds (NODE_ENV === "production")
// these become no-ops so we don't leak debug info or add I/O overhead.
// In development we forward to the real console for a normal debugging UX.
const isProd = process.env.NODE_ENV === "production";

export const devLog = {
  error: (...args) => { if (!isProd) console.error(...args); },
  warn: (...args) => { if (!isProd) console.warn(...args); },
  info: (...args) => { if (!isProd) console.info(...args); },
};
